var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useState, useEffect } from 'react';
import { BellIcon, BellSlashIcon, CurrencyDollarIcon, ExclamationTriangleIcon, ClockIcon } from '@heroicons/react/24/outline';
import { getNotificationPreferences, updateNotificationPreferences } from '../../actions/users';
import { showToast } from '../../utils/toastUtils';
var NotificationPreferencesPanel = function () {
    var _a = useState({
        balance: true,
        balance_zero: true,
        campaign_stopped: true,
        account_stopped: true,
        quiet_hours: {
            enabled: false,
            start: '22:00',
            end: '07:00'
        }
    }), preferences = _a[0], setPreferences = _a[1];
    var _b = useState(true), loading = _b[0], setLoading = _b[1];
    var _c = useState(false), saving = _c[0], setSaving = _c[1];
    var _d = useState(false), isDirty = _d[0], setIsDirty = _d[1];
    useEffect(function () {
        loadPreferences();
    }, []);
    var loadPreferences = function () { return __awaiter(void 0, void 0, void 0, function () {
        var prefs, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, 3, 4]);
                    return [4 /*yield*/, getNotificationPreferences()];
                case 1:
                    prefs = _a.sent();
                    setPreferences(prefs);
                    return [3 /*break*/, 4];
                case 2:
                    error_1 = _a.sent();
                    console.error('Erro ao carregar preferências:', error_1);
                    return [3 /*break*/, 4];
                case 3:
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var handleToggle = function (key) {
        setPreferences(function (prev) {
            var _a;
            return (__assign(__assign({}, prev), (_a = {}, _a[key] = !prev[key], _a)));
        });
        setIsDirty(true);
    };
    var handleQuietHoursToggle = function () {
        setPreferences(function (prev) { return (__assign(__assign({}, prev), { quiet_hours: __assign(__assign({}, prev.quiet_hours), { enabled: !prev.quiet_hours.enabled }) })); });
        setIsDirty(true);
    };
    var handleTimeChange = function (field, value) {
        setPreferences(function (prev) {
            var _a;
            return (__assign(__assign({}, prev), { quiet_hours: __assign(__assign({}, prev.quiet_hours), (_a = {}, _a[field] = value, _a)) }));
        });
        setIsDirty(true);
    };
    var handleSave = function () { return __awaiter(void 0, void 0, void 0, function () {
        var error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setSaving(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, updateNotificationPreferences(preferences)];
                case 2:
                    _a.sent();
                    setIsDirty(false);
                    showToast('success', 'Preferências atualizadas com sucesso!');
                    return [3 /*break*/, 5];
                case 3:
                    error_2 = _a.sent();
                    console.error('Erro ao salvar preferências:', error_2);
                    showToast('error', 'Erro ao salvar preferências');
                    return [3 /*break*/, 5];
                case 4:
                    setSaving(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    if (loading) {
        return (React.createElement("div", { className: "flex items-center justify-center p-8" },
            React.createElement("div", { className: "animate-spin rounded-full h-8 w-8 border-b-2 border-green-400" })));
    }
    var notificationTypes = [
        {
            key: 'balance',
            icon: CurrencyDollarIcon,
            title: 'Saldo Baixo (5 dias)',
            description: 'Receba alertas quando faltarem 5 dias para acabar o saldo.',
            color: 'yellow'
        },
        {
            key: 'balance_zero',
            icon: ExclamationTriangleIcon,
            title: 'Saldo Zerado',
            description: 'Receba alertas quando o saldo acabar.',
            color: 'red'
        },
        {
            key: 'campaign_stopped',
            icon: BellSlashIcon,
            title: 'Campanhas Paradas',
            description: 'Receba alertas quando uma campanha precisar de atenção (sem visualizações recentes).',
            color: 'orange'
        },
        {
            key: 'account_stopped',
            icon: ExclamationTriangleIcon,
            title: 'Contas Paradas',
            description: 'Receba alertas quando uma conta precisar de atenção (sem visualizações recentes).',
            color: 'red'
        }
    ];
    return (React.createElement("div", { className: "flex flex-col gap-6" },
        React.createElement("h3", { className: "text-xl font-bold text-green-300 flex items-center gap-2" },
            React.createElement(BellIcon, { className: "w-6 h-6" }),
            "Gerenciar Notifica\u00E7\u00F5es"),
        React.createElement("div", { className: "grid gap-4" }, notificationTypes.map(function (_a) {
            var key = _a.key, Icon = _a.icon, title = _a.title, description = _a.description, color = _a.color;
            return (React.createElement("div", { key: key, className: "border rounded-xl p-5 transition-all ".concat(preferences[key]
                    ? "border-".concat(color, "-500/30 bg-").concat(color, "-500/10")
                    : 'border-gray-700/40 bg-gray-800/40') },
                React.createElement("div", { className: "flex items-start justify-between gap-4" },
                    React.createElement("div", { className: "flex items-start gap-3 flex-1" },
                        React.createElement(Icon, { className: "w-6 h-6 mt-1 ".concat(preferences[key]
                                ? "text-".concat(color, "-400")
                                : 'text-gray-500') }),
                        React.createElement("div", { className: "flex-1" },
                            React.createElement("h4", { className: "font-semibold text-base ".concat(preferences[key]
                                    ? 'text-white'
                                    : 'text-gray-400') }, title),
                            React.createElement("p", { className: "text-sm text-gray-400 mt-1" }, description))),
                    React.createElement("button", { onClick: function () { return handleToggle(key); }, className: "relative inline-flex h-6 w-11 items-center rounded-full transition-colors ".concat(preferences[key]
                            ? 'bg-green-600'
                            : 'bg-gray-600') },
                        React.createElement("span", { className: "inline-block h-4 w-4 transform rounded-full bg-white transition-transform ".concat(preferences[key]
                                ? 'translate-x-6'
                                : 'translate-x-1') })))));
        })),
        React.createElement("div", { className: "border border-blue-500/30 bg-blue-500/10 rounded-xl p-5" },
            React.createElement("div", { className: "flex items-start justify-between gap-4 mb-4" },
                React.createElement("div", { className: "flex items-start gap-3 flex-1" },
                    React.createElement(ClockIcon, { className: "w-6 h-6 mt-1 ".concat(preferences.quiet_hours.enabled
                            ? 'text-blue-400'
                            : 'text-gray-500') }),
                    React.createElement("div", { className: "flex-1" },
                        React.createElement("h4", { className: "font-semibold text-base ".concat(preferences.quiet_hours.enabled
                                ? 'text-white'
                                : 'text-gray-400') }, "Hor\u00E1rio Silencioso"),
                        React.createElement("p", { className: "text-sm text-gray-400 mt-1" }, "N\u00E3o enviar notifica\u00E7\u00F5es durante determinado per\u00EDodo."))),
                React.createElement("button", { onClick: handleQuietHoursToggle, className: "relative inline-flex h-6 w-11 items-center rounded-full transition-colors ".concat(preferences.quiet_hours.enabled
                        ? 'bg-blue-600'
                        : 'bg-gray-600') },
                    React.createElement("span", { className: "inline-block h-4 w-4 transform rounded-full bg-white transition-transform ".concat(preferences.quiet_hours.enabled
                            ? 'translate-x-6'
                            : 'translate-x-1') }))),
            preferences.quiet_hours.enabled && (React.createElement("div", { className: "flex gap-4 items-center ml-9" },
                React.createElement("div", null,
                    React.createElement("label", { className: "block text-xs text-blue-200 mb-1" }, "In\u00EDcio"),
                    React.createElement("input", { type: "time", value: preferences.quiet_hours.start, onChange: function (e) { return handleTimeChange('start', e.target.value); }, className: "bg-gray-700 text-white px-3 py-2 rounded-lg border border-blue-400/20 focus:outline-none focus:border-blue-400" })),
                React.createElement("div", null,
                    React.createElement("label", { className: "block text-xs text-blue-200 mb-1" }, "Fim"),
                    React.createElement("input", { type: "time", value: preferences.quiet_hours.end, onChange: function (e) { return handleTimeChange('end', e.target.value); }, className: "bg-gray-700 text-white px-3 py-2 rounded-lg border border-blue-400/20 focus:outline-none focus:border-blue-400" })),
                React.createElement("span", { className: "text-xs text-blue-300 mt-5" }, "(Ex: 22:00 \u00E0s 07:00 = sem notifica\u00E7\u00F5es durante a noite)")))),
        isDirty && (React.createElement("div", { className: "bg-blue-500/20 border border-blue-500/40 text-blue-200 p-4 rounded-lg" },
            React.createElement("p", { className: "text-sm" },
                "\u26A0\uFE0F Voc\u00EA tem altera\u00E7\u00F5es n\u00E3o salvas. Clique em ",
                React.createElement("strong", null, "\"Salvar Altera\u00E7\u00F5es\""),
                " abaixo para aplicar."))),
        isDirty && (React.createElement("button", { onClick: handleSave, disabled: saving, className: "w-full bg-green-600 hover:bg-green-700 disabled:bg-gray-600 disabled:cursor-not-allowed text-white font-bold py-3 px-6 rounded-lg transition shadow-lg" }, saving ? 'Salvando...' : 'Salvar Alterações'))));
};
export default NotificationPreferencesPanel;
